import { Document, SignatureFieldMetadata } from "../../data/model";

export class Signature {
    constructor(
        public index: number,
        public metadata: SignatureFieldMetadata,
        public left: number,
        public top: number,
        public width: number,
        public height: number,
        public dataUrl: string,
    ) {}
}

export class DocumentState {
    constructor(
        public document: Blob = null,
        public documentUrl: string = null,
        public metadata: Document = null,
        public signatures: Signature[] = [],
        public dirty = true,
        public beingBuilt = false,
        public lastError: string = null,
        public pageCount = 0,
        public currentPage: number = null,
    ) {}
}
